<template>
  <div
    v-bind="$attrs"
    class="ui-divider"
    :class="`ui-divider--${direction}`"
    role="separator"
    :aria-orientation="direction"
  />
</template>

<script setup lang="ts">
  defineOptions({ inheritAttrs: false, name: 'UiDivider' })
  withDefaults(defineProps<{ direction?: 'horizontal' | 'vertical' }>(), {
    direction: 'horizontal',
  })
</script>

<style scoped>
  .ui-divider {
    flex: none;
    background: var(--color-border-border-secondary);
  }

  .ui-divider--horizontal {
    width: 100%;
    height: 1px;
  }

  .ui-divider--vertical {
    align-self: stretch;
    width: 1px;
  }
</style>
